<template>
    <div class="container" v-if="page !== null && upload_code !== null">
        <form class="section">
            <b-field label="Title">
                <b-input type="text" name="title" v-model.lazy.trim="page.title" v-validate="titleValidation"></b-input>
            </b-field>
            <b-field label="Content" class="content">
                <froala :content="page" height="450" :upload_code="upload_code" v-if="!editing || (editing && page.content.length > 0)"></froala>
            </b-field>
            <b-field>
                <b-checkbox v-model="page.published">Published</b-checkbox>
            </b-field>
            <b-field grouped>
                <div class="control">
                    <button class="button is-primary" type="button" @click="savePage">{{ editing? 'Update' : 'Create' }}
                    </button>
                </div>
                <div class="control">
                    <button class="button" type="button" @click="router.push('/admin/2')">Cancel</button>
                </div>
                <div class="control">
                    <button class="button is-danger" type="button" @click="deletePage" v-if="editing">Delete</button>
                </div>
            </b-field>
        </form>
    </div>
    <loader v-else></loader>
</template>

<script>
import Froala from './FroalaTmp';
import Loader from '../Loader';
import BInput from 'buefy/src/components/input/Input';
import BCheckbox from 'buefy/src/components/checkbox/Checkbox';

export default {
  components: {
    BCheckbox,
    BInput,
    Loader,
    Froala,
  },

  name: 'admin-page-form',

  computed: {
    titleValidation() {
      let val = {
        required: true,
        min: 1,
        max: 255,
      };

      if (!this.editing) val.pageNameAvailable = true;

      return val;
    },

    editing() {
      return this.$route.name === 'AdminPageEdit';
    },

    loading() {
      return this.$store.state.adminPage.loading;
    },

    page() {
      return this.$store.state.adminPage.page;
    },

    upload_code() {
      return this.$store.state.image.upload_code;
    },
  },

  created() {
    this.$store.dispatch('image/getCode');

    if (this.$route.name === 'AdminPageEdit') {
      this.$store.dispatch('adminPage/load', this.$route.params.id);
    } else {
      this.$store.commit('adminPage/setBlank');
    }
  },

  destroyed() {
    this.$store.commit('adminPage/setPage', null);
  },

  methods: {
    savePage() {
      this.$validator.validateAll().then((valid) => {
        if (valid) {
          this.$store.dispatch('adminPage/save').then(() => this.$router.push('/admin/2'));
        }
      });
    },

    deletePage() {
      this.$dialog.confirm({
        message: 'Delete this page?',
        onConfirm: () => {
          this.$store.dispatch('adminPage/delete').then(() => this.$router.replace('/admin/2'));
        },
      });
    },
  },
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/AdminPageForm.vue